import { render, staticRenderFns } from "./Confetti2.vue?vue&type=template&id=7f4a6794&"
import script from "./Confetti2.vue?vue&type=script&lang=js&"
export * from "./Confetti2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports